
import React from 'react';

export default function MissionSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-semibold mb-6">
            Our Mission
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-6"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            What We Stand For
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Our mission is to provide homeowners in El Paso with a fast, fair, and
            hassle‑free way to sell their properties, regardless of condition or
            situation.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {/* Card 1 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-hand-heart-fill text-teal-600 text-3xl" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Fair &amp; Honest</h3>
            <p className="text-gray-700 leading-relaxed">
              We provide transparent offers based on current market values. We have a
              real track record in El Paso TX and believe in treating every homeowner
              with respect and integrity.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-shield-check-fill text-teal-600 text-3xl" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">End Buyer</h3>
            <p className="text-gray-700 leading-relaxed">
              TRex RE LLC is an end buyer. We are not a middle man. Unlike wholesalers,
              we actually are real estate investors with a portfolio of properties in
              El Paso.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-customer-service-2-fill text-teal-600 text-3xl" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Local Experts</h3>
            <p className="text-gray-700 leading-relaxed">
              With deep knowledge of El Paso neighborhoods and property values, we
              understand the local market and can provide competitive cash offers
              quickly.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
